import React from 'react';
import { Router, Route, IndexRoute } from 'dva/router';
import layout from '../../common/layout';
import NotFound from '../../containers/NotFound';//页面404
import Finance from '../../containers/Finance/Finance';

function RouterConfig({ history }) {
  return (
    <Router history={history}>
      <Route path="/" component={layout} >
        <IndexRoute component={Finance} />
        <Route path="/" component={Finance} />
        <Route path="/finance" component={Finance} />
      </Route>
      <Route path="*" component={NotFound}></Route>
    </Router>
  );
}
export default RouterConfig;



// WEBPACK FOOTER //
// ./src/scripts/router/finance/index.js